module.exports = __webpack_public_path__ + "static/BundesSans-Web-Bold-0365e6c28a0c904c917d25f8dc79ab28.woff";